/* eslint no-control-regex: 1 */
import {bridge} from './bridge.js';

var util = {
    format: function (param) {
        if (typeof param == 'undefined') {
            return '';
        }
        if (typeof param != 'object') {
            throw new Error("data sended to the server must be 'object'");
        }
        var s = [];
        for (var j in param) {
            s.push(encodeURIComponent(j) + '=' + encodeURIComponent(param[j]));
        }
        return s.join('&').replace(/%20/g, '+');
    },
    _deFormat: function (param) {
        var p = {};
        var temp = param.split('&');
        for (var i = 0, l = temp.length; i < l; i++) {
            var t = temp[i].split('=');
            if (t[0] === 'extra_data') {
                p[t[0]] = JSON.parse(decodeURIComponent(t[1]));
            } else if (t[0] === 'platform') {
                p[t[0]] = parseInt(decodeURIComponent(t[1]));
            } else {
                p[t[0]] = decodeURIComponent(t[1]);
            }
        }
        return p;
    },
    getUrlStrs: function (href) {
        href = href || window.location.search;
        var data = {},
            reg = new RegExp('([^?=&]+)(=([^&]*))?', 'g');
        href &&
        href.replace(reg, function ($0, $1, $2, $3) {
            data[$1] = $3;
        });
        return data;
    },
    _getUrlStrs: (function (href) {
        href = href || window.location.search;
        var data = {},
            reg = new RegExp('([^?=&]+)(=([^&]*))?', 'g');
        href &&
        href.replace(reg, function ($0, $1, $2, $3) {
            data[$1] = $3;
        });
        return data;
    })(),
    countChars: function (str, len, flag) {
        var strLen = str.replace(/[\u4e00-\u9fa5\s]/g, '**').replace(/[A-Z]/g, '**').length,
            newStr = [],
            totalCount = 0;
        if (strLen <= len) {
            return str;
        } else {
            for (var i = 0; i < strLen; i++) {
                var nowValue = str.charAt(i);
                if (/[^\x00-\xff]/.test(nowValue) || /[A-Z]/.test(nowValue)) {
                    totalCount += 2;
                } else {
                    totalCount += 1;
                }
                newStr.push(nowValue);
                if (totalCount >= len) {
                    break;
                }
            }
            if (flag) {
                return newStr.join('');
            } else {
                return newStr.join('') + '...';
            }
        }
    },
    getUniversalParameters: function () {
        var querystring;
        if ((querystring = /.+(\?.+)/.exec(window.location.href))) {
            querystring = querystring[1];
        } else {
            querystring = '';
        }
        return querystring;
    },
    getCookie: function (c_name) {
        if (document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + '=');
            let c_end;
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                c_end = document.cookie.indexOf(';', c_start);
                if (c_end == -1) c_end = document.cookie.length;
                return unescape(document.cookie.substring(c_start, c_end));
            }
        }
        return '';
    },
    isLogin: function () {
        return util.getCookie('miveshow_session_id');
    },
    getPosition: function (node) {
        var posx = 0,
            posy = 0;
        while (node.offsetParent) {
            posy = posy + node.offsetTop;
            posx = posx + node.offsetLeft;
            node = node.offsetParent;
        }
        return {
            x: posx,
            y: posy
        };
    },
    isIos: function () {
        if (!navigator) {
            return false;
        }
        if (!navigator.userAgent) {
            return false;
        }
        return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    },
    _toTwoDigit: function (num) {
        return num < 10 ? '0' + num : num;
    },
    formatDate: function (time, formation) {
        var date = new Date(time);
        var _temp_year = date.getFullYear();
        var _temp_month = date.getMonth() + 1;
        var _temp_date = date.getDate();
        var _temp_hour = date.getHours();
        var _temp_minute = date.getMinutes();
        var _temp_second = date.getSeconds();

        function _get_date_part(part) {
            switch (part) {
                case 'yyyy':
                    return _temp_year;
                case 'yy':
                    return _temp_year.toString().slice(-2);
                case 'MM':
                    return util._toTwoDigit(_temp_month);
                case 'M':
                    return _temp_month;
                case 'dd':
                    return util._toTwoDigit(_temp_date);
                case 'd':
                    return _temp_date;
                case 'HH':
                    return util._toTwoDigit(_temp_hour);
                case 'H':
                    return _temp_hour;
                case 'hh':
                    return util._toTwoDigit(_temp_hour > 12 ? _temp_hour - 12 : _temp_hour);
                case 'h':
                    return _temp_hour > 12 ? _temp_hour - 12 : _temp_hour;
                case 'mm':
                    return util._toTwoDigit(_temp_minute);
                case 'm':
                    return _temp_minute;
                case 'ss':
                    return util._toTwoDigit(_temp_second);
                case 's':
                    return _temp_second;
                default:
                    return part;
            }
        }

        return formation.replace(/y+|m+|d+|h+|s+|H+|M+/g, _get_date_part);
    },
    clientLogin: function () {
        try {
            if (util.isIos()) {
                bridge.post('login', {forward: 'refresh'});
            } else {
                androidObj.call('local://login');
            }
        } catch (e) {
            console.log(e);
        }
    },
    shareTwitter: function (shareObj, islogin) {
        var params = util._getUrlStrs;
        var _shareObj = {
            title: shareObj.title || '',
            content: shareObj.content || '',
            url: shareObj.url || '',
            platform: 1,
            image_url: shareObj.image_url || ''
        };
        if (!util.isIos()) {
            _shareObj.android_extra_data = JSON.stringify({name: 'webshare'});
        }
        for (var o in shareObj) {
            _shareObj[o] = shareObj[o];
        }
        try {
            if (params.v) {
                if (!islogin) {
                    util.clientLogin();
                    return;
                }
                util.openUrl('local://share?' + util.format(_shareObj));
            } else {
                var share_url =
                    'https://twitter.com/intent/tweet?text=' +
                    encodeURIComponent(_shareObj.title + _shareObj.content) +
                    '&url=' +
                    encodeURIComponent(_shareObj.url);
                window.location.href = share_url;
            }
        } catch (e) {
            console.log(e);
        }
    },
    configShare: function (shareObj) {
        //title,content,url,image_url,extra_data,android_extra_data
        var _shareObj = {
            content: shareObj.content || '',
            url: shareObj.url || ''
        };
        for (var o in shareObj) {
            _shareObj[o] = shareObj[o];
        }
        _shareObj.extra_data && (_shareObj.extra_data = _shareObj.android_extra_data);
        util.openUrl('local://config_share?' + util.format(_shareObj));
    },
    showShareView: function (shareObj) {
        var _shareObj = {
            content: shareObj.content || '',
            url: shareObj.url || ''
        };
        for (var o in shareObj) {
            _shareObj[o] = shareObj[o];
        }
        _shareObj.extra_data && (_shareObj.extra_data = _shareObj.android_extra_data);
        util.openUrl('local://show_share_view?' + util.format(_shareObj));
    },
    openUrl: function (open_url) {
        var params = util._getUrlStrs;
        try {
            if (!params.v && !params.share) {
                window.location.href = 'https://www.doki.live/download';
                return;
            }
            var _hasQueryString = open_url.indexOf('?') != -1;
            if (params.event_refer_json) {
                if (_hasQueryString) {
                    open_url = open_url + '&event_refer_json=' + params.event_refer_json;
                } else {
                    open_url = open_url + '?event_refer_json=' + params.event_refer_json;
                }
            }
            if (util.isIos()) {
                //var open_url='local://bind?platform=phone'
                var result;
                if (!_hasQueryString & !params.event_refer_json) {
                    var re = new RegExp('//(.+)', 'g');
                    if ((result = re.exec(open_url))) {
                        bridge.post(result[1]);
                    }
                } else {
                    var re = new RegExp('//(.+)\\?(.+)', 'g');
                    if ((result = re.exec(open_url))) {
                        var p = util._deFormat(result[2]);
                        bridge.post(result[1], p);
                    }
                }
            } else {
                androidObj.call(open_url);
            }
        } catch (e) {
            console.log(e);
        }
    },
    getStaticData: function (store, page, page_size) {
        var length = store.length;
        var page_size = page_size || 10;
        var start = page * page_size,
            end = (page + 1) * page_size;
        end = Math.min(end, length);
        start = Math.min(start, length);

        return {
            data: store.slice(start, end),
            has_more: end != length
        };
    },
    translate: function (str, replace_ary) {
        var reg = str.match(/%s|%d/g);
        if (reg) {
            for (var i = 0; i < reg.length; i++) {
                str = str.replace(reg[i], replace_ary[i]);
            }
        }
        return str;
    },
    isIphonex: (function () {
        var ratio = window.devicePixelRatio || 1;
        var screen = {
            width: window.screen.width * ratio,
            height: window.screen.height * ratio
        };
        return function () {
            return /iphone/gi.test(navigator.userAgent) && screen.height >= 2436;
        };
    })()(),
    getVersion: function (v) {
        var _varray = v.split('.');
        if (_varray.length === 2) {
            _varray.push('0');
        }
        if (_varray.length != 3) {
            return 10000;
        }
        return +_varray[0] * 10000 + +_varray[1] * 100 + +_varray[2];
    },
    getEnv: function () {
        var _htmlNode = document.getElementsByTagName('html')[0];
        var _env = _htmlNode.getAttribute('env');
        if (_env) {
            return _env;
        }
        return 'cdn';
    },
    getLang: function () {
        var _htmlNode = document.getElementsByTagName('html')[0];
        var _lang = _htmlNode.getAttribute('lang');
        if (_lang) {
            return _lang;
        }
        return 'ja';
    },
    clientUpload:function (p) {
        var param={
            type:0,
            maximum_duration: 30,
            minimum_duration: 5,
            function_did:function(data,error){},
            function_name:"callback"
        };
        for(var o in  p){
            param[o]=p[o];
        }
        if(util.isIos()){
            if(!param.type){
                bridge.post('event.upload.file',{
                    type: param.type,
                    function_name:param.function_name
                },param.function_did);
            }else{
                bridge.post('event.upload.file',{
                    type: param.type,
                    maximum_duration: param.maximum_duration,
                    minimum_duration: param.minimum_duration,
                    function_name:param.function_name
                },param.function_did);
            }
        }else{
            if (typeof androidObj != 'undefined') {
                if(!param.type){
                    androidObj.call("local://event.upload.file?type="+param.type+"&callback="+param.function_name);
                }else{
                    androidObj.call("local://event.upload.file?type="+param.type+"&maximum_duration="+param.maximum_duration+"&minimum_duration="+param.minimum_duration+"&callback="+param.function_name);
                }
            }else{
                alert("no androidobject");
            }
        }
    },
    updateConfirm:function () {
        if(confirm("イベントを参加するには最新バージョンにアップデートが必要です。")){
            if(util.isIos()){
                bridge.post('open_app', {url:"https://itunes.apple.com/app/id1322899772"});
            }else{
                androidObj.call("local://market?package=net.imusic.android.dokidoki");
            }
        }
    }
};
export {util};
